import { Component, OnInit, inject, computed } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NovaButton } from '@rds-nova/angular-button';
import { NovaIcon } from '@rds-nova/angular-icon';
import { NovaLink } from '@rds-nova/angular-link';
import { SimpleDialogComponent } from 'src/app/shared/components/simple-dialog/simple-dialog.component';
import { DEFAULT_APPLICATION_PHONE_NUMBER } from 'src/app/shared/constants';

import { CaptureType } from '../../capture-type.enum';
import { IdVerificationStore } from 'src/app/features/check-in/store/id-verification-store';
import { FaceDetectionStore } from 'src/app/features/check-in/store/face-detection.store';
import { NgTemplateOutlet } from 'node_modules/@angular/common';
import { TrackedButtonDirective } from 'src/app/core/analytics/directives/tracked-button.directive';
import { TrackedLinkDirective } from 'src/app/core/analytics/directives/tracked-link.directive';

@Component({
  selector: 'app-image-review-step',
  templateUrl: './image-review-step.component.html',
  styleUrls: ['./image-review-step.component.scss'],
  imports: [
    TranslatePipe,
    NgTemplateOutlet,
    NovaButton,
    NovaIcon,
    NovaLink,
    SimpleDialogComponent,
    TrackedButtonDirective,
    TrackedLinkDirective,
  ],
})
export class ImageReviewStepComponent implements OnInit {
  private readonly idVerificationStore = inject(IdVerificationStore);
  private readonly faceDetectionStore = inject(FaceDetectionStore);

  documentType = this.idVerificationStore.currentCaptureType;
  image = this.idVerificationStore.imageToReview;
  supportPhoneNumber = DEFAULT_APPLICATION_PHONE_NUMBER;

  isFaceComparisonLoading = this.faceDetectionStore.isFaceComparisonLoading;
  isFaceComparisonSuccessful = this.faceDetectionStore.isKnownFace;
  hasError = computed(
    () =>
      this.documentType() === CaptureType.IdFront &&
      !this.isFaceComparisonSuccessful(),
  );
  headingTranslationKey = computed(() => {
    return this.hasError()
      ? `id-verification.review.${this.documentType()}.headingFailed`
      : `id-verification.review.${this.documentType()}.headingSuccess`;
  });
  subheadingTranslationKey = computed(() => {
    return this.hasError()
      ? `id-verification.review.${this.documentType()}.subheadingFailed`
      : `id-verification.review.${this.documentType()}.subheadingSuccess`;
  });

  async ngOnInit(): Promise<void> {
    if (this.documentType() === CaptureType.IdFront) {
      await this.faceDetectionStore.compareFace(this.image());
    }
  }

  retakeImage(): void {
    this.idVerificationStore.retakePhoto();
  }

  async submitImage(): Promise<void> {
    if (this.documentType() === CaptureType.IdFront) {
      if (this.isFaceComparisonSuccessful()) {
        await this.idVerificationStore.acceptCaptureResult();
      }
    } else {
      await this.idVerificationStore.acceptCaptureResult();
    }
  }
}
